import { initialModalState } from './initialStates';
import { ActionTypes }       from 'actions/types';
import { modalStateType }    from './types';
 
export const initialState: modalStateType = initialModalState;

const modalReducer = (state = initialState, action: ActionTypes) => {

switch (action.type) {


case 'SET_MODAL_STATE':
  {
     return {
       ...state,
       ...action.payload
     }
 }



case 'RESET_STATE':   
 {
    return initialState
    
}






// -      -      -      -      -      -      -      -      -      -      -      -


    default: return state;
  }
};

export type reducerType = ReturnType<typeof modalReducer>;

export { modalReducer };
